import logo from '@/assets/images/coloredIcon.png';
import { useAgentChat } from '../../contexts/AgentChatContext';
import { AgentChatInput } from './AgentChatInput';
import { AgentChatMessages } from './AgentChatMessages';

interface DynamicPageAgentChatProps {
  agentName: string;
  className?: string;
  placeholder?: string;
}

export function DynamicPageAgentChat({
  className = '',
  // placeholder = 'Ask me anything about this dynamic page...',
}: DynamicPageAgentChatProps) {
  const {
    getAgentState,
    sendMessage,
    stopStreaming,
    promptContexts,
    setPromptContexts,
    updatePromptContext,
    addPromptContext,
  } = useAgentChat();
  const agentState = getAgentState();
  const hasMessages = agentState.messages.length > 0;

  // Get user message history for arrow-key navigation
  const userMessageHistory = agentState.messages
    .filter((msg) => msg.type === 'user')
    .map((msg) => msg.content)
    .reverse();

  // Get thread ID for file uploads
  const threadId =
    agentState.currentThreadId || agentState.currentRunId || 'default';

  return (
    <div
      className={`flex h-full flex-col ${className}`}
      style={{
        background: 'linear-gradient(180deg, #F7F5FF 0%, #E5EEFF 100%)',
      }}
    >
      <div
        className={`pointer-events-none absolute inset-x-0 top-3/7 -translate-y-1/2 overflow-hidden whitespace-nowrap transition-all duration-700 ease-in-out ${
          hasMessages
            ? 'pointer-events-none max-h-0 scale-95 opacity-0'
            : 'max-h-104 scale-100 opacity-100'
        }`}
      >
        <div className="flex flex-col items-center gap-2.5 text-center">
          <img src={logo} alt="logo" className={'w-12'} />
          <h1 className="font-manrope text-2xl font-medium -tracking-[0.01em]">
            How can I help you?
          </h1>
        </div>
      </div>

      {/* Messages Container */}
      <AgentChatMessages
        messages={agentState.messages}
        isWorking={agentState.isWorking}
        isLoading={agentState.isLoading}
        lastUpdated={agentState.lastUpdated}
      />

      {/* Input Component */}
      <AgentChatInput
        onSendMessage={sendMessage}
        onStopMessage={stopStreaming}
        placeholder="Coming Soon"
        disabled={true || agentState.isLoading}
        isStreaming={agentState.isStreaming}
        className="p-2"
        contextTypes={[{ type: 'file', location: 'dropdown' }]}
        promptContexts={promptContexts}
        setPromptContexts={setPromptContexts}
        updatePromptContext={updatePromptContext}
        addPromptContext={addPromptContext}
        userMessageHistory={userMessageHistory}
        threadId={threadId}
      />
    </div>
  );
}
